import { call, put, select } from 'redux-saga/effects';
import { getR2rCompatibleData as getR2rCompatibleDataAda } from '@bitComponents/adabyron/catalog';
import { WEB_SERVICES } from './webServices';

const contextStore = state => state.context.data;

export function* getR2RCompatibility(params) {
  const {
    normalizeHttpErrors,
    reduxUpdate,
    idPO,
    type = "incluido",
  } = params;
  try {
    const context = yield select(contextStore);
    const response = yield call(getR2rCompatibleDataAda, { productOffering: idPO, type }, context);

    return response;
  } catch (error) {
    const { errorUpdate } = reduxUpdate;
    const errorNormalized = yield call(normalizeHttpErrors, WEB_SERVICES.R2R_COMPATIBLE, error);
    if (errorUpdate) {
      yield put(errorUpdate(errorNormalized));
    }
    throw error;
  }
}
